import { render, staticRenderFns } from "./WizardDialog.vue?vue&type=template&id=be930dce&"
import script from "./WizardDialog.vue?vue&type=script&lang=js&"
export * from "./WizardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports